<template>  
  <div>
    <v-card flat>      
        <div fluid>
          <v-row >
            <v-expansion-panels
          
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel  >
                <v-expansion-panel-header >
                  Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content 
                    
                >
                  <!-- =============Start Search Condition============= -->
                  <v-row align="center" dense >
                    <!-- From Date -->
                    <v-col
                      class="pl-0"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >                           
                    <DxDateBox  
                        label="From date"                            
                        :value="stDate" 
                        display-format="yyyy-MM-dd" 
                        :acceptCustomValue="false"
                        @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                        dense
                    /> 
                    </v-col>
                    <!-- To date -->
                    <v-col
                      class="pl-0"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >                           
                    <DxDateBox  
                        label="To date"                            
                        :value="edDate" 
                        display-format="yyyy-MM-dd" 
                        :acceptCustomValue="false"
                        @value-changed="e => {edDate = e.value && getStrFormat(e.value)}"
                        dense
                    />
                    </v-col> 
                    <!-- Status  -->
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                    >                    
                    <v-row dense>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          v-model="statCd1"
                          label="Not yet"
                          color="red"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          x-small
                          v-model="statCd3"
                          label="Receipt"
                          color="indigo"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          x-small
                          v-model="statCd5"
                          label="Reply final"
                          color="green darken-1"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          x-small
                          v-model="statCd7"
                          label="QM return"
                          color="blue accent-4"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          x-small
                          v-model="statCd9"
                          label="Final"
                          color="amber"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="3"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          x-small
                          v-model="statCdCan"
                          label="Withdraw"
                          color="orange"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                      <!-- <div class="ma-0">
                        <v-container 
                          :style="{ 'width': '100%',
                                    'padding': '0px',
                                    'margin-right': 'auto',
                                    'margin-left': 'auto', }"                           
                                                                >
                          <v-select
                            class="ma-0 mt-2"
                            v-model="chkStatus"
                            :items="status"
                            label="Status"
                            multiple
                            outlined
                            dense
                            height="30px"
                            :style="{'font-size': '9px', }"  
                            @input="changed"                                
                          >
                          </v-select>
                        </v-container>
                      </div>  -->
                    </v-col>
                    <!-- Ship No -->
                    <v-col                            
                      class="mt-2"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-select 
                        label="Ship No"
                        v-model="shipNo" 
                        :items="shipNoList" 
                        return-object 
                        item-value="shipNo" 
                        outlined
                        dense
                      >
                      </v-select>
                    </v-col>  
                    <!-- Publisher -->
                    <v-col                            
                      class="mt-2"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-select 
                        label="Publisher"
                        v-model="publisherName" 
                        :items="publisherNameList" 
                        return-object 
                        item-value="publisherName" 
                        outlined
                        dense
                      >
                      </v-select>
                    </v-col>   
                    <!-- Department Division -->
                    <v-col                            
                      class="mt-2"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-select 
                        label="Division"
                        v-model="respClsName" 
                        :items="respClsNameList" 
                        return-object 
                        item-value="respClsName" 
                        outlined
                        dense
                      >
                      </v-select>
                    </v-col>                      
                    <!-- Department Section-->
                    <v-col
                      class="mt-2"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-select 
                        label="Department"
                        v-model="deptName" 
                        :items="deptNameList" 
                        item-value="deptName" 
                        return-object 
                        outlined 
                        dense
                      >
                      </v-select>
                    </v-col> 
                    <!-- QM PIC List-->
                    <v-col
                      class="mt-2"
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-select 
                        label="Employee"
                        v-model="empName" 
                        :items="empNameList" 
                        item-value="empName" 
                        return-object 
                        outlined 
                        dense
                      >
                      </v-select>
                    </v-col> 
                  <!-- Button Retrieve -->
                    <v-col
                      cols="6"
                      sm="6"
                      md="3"
                      lg="2"
                    >
                      <v-btn 
                      
                        height = "30px"
                        class="mt-2 "
                        block
                        dense
                        color="success"
                        @click="btnRetrieve"
                      >
                        <v-icon left>
                          mdi-magnify
                          <!-- {{ icons.mdiMapSearch }} -->
                        </v-icon>
                        Retrieve
                      </v-btn>
                    </v-col>
                  </v-row>
                    <!-- ==========End Search Condition================= -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
        <!-- Change theme -->
        <v-fab-transition>
          <v-btn
            @click="dark = !dark"
            absolute
            top
            right
            fab
            height = "30"
            width = "30"
          >
            <v-icon>mdi-invert-colors</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card> 
    
    <v-card class="mt-2" > 
      <!-- Search filter --> 
      <v-card-title >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>  

      <v-data-table
        :mobile-breakpoint="800"
        :mobile="mobile"
        :items-per-page="listSize"
        :headers="headers"
        :items="gridMainList"
        :search="search"
        :sort-by="[]"
        :sort-desc="[false]"
        :dense="true"
        :dark="dark"
      >
              
        <template v-slot:[`item.details`]="{ item  }">
          <v-chip
            class="mt-1 mr-2"   
            :color="getColor(item.rno)"
            :dark="dark"
            small
          >
            {{ item.rno }}
          </v-chip>
          
          <v-btn  
            class="mt-1"              
            x-small
            color="primary"
            :dark="dark"
            @click="showDetailComment(item)"
          >
            Show Comment Detail
          </v-btn>
        
        </template>
        <!-- Show Action department -->
        <template v-slot:[`item.action1`]="{ item }">                     
          <v-btn
            outlined
            x-small
            color="primary"
            :dark="dark"
            @click="showItemAction(item, -1)"
          >
            {{ item.nm1st}}
          </v-btn>
          
          <v-chip
            class="ml-1"
            small
            :color="setColorStatus(item.rstatCd)"
            :dark="dark"
            @click="showItemAction(item, -1)"
          >
            {{ item.statNm1}}
          </v-chip>
        </template>

        <template v-slot:[`item.action2`]="{ item }">                     
          <v-btn 
            outlined           
            x-small
            color="primary"
            :dark="dark"
            @click="showItemAction(item, 1)"
            v-if="item.nm2nd != '' "
          >
            {{ item.nm2nd}}
          </v-btn>
          
          <v-chip
            class="ml-1"
            small
            :color="setColorStatus(item.cstatCd)"
            :dark="dark"
            @click="showItemAction(item, 1)"
            v-if="item.statNm2 != '' "
          >
            {{ item.statNm2}}
          </v-chip>
        </template>

        <template v-slot:[`item.subject`]="{ item  }">
          <a 
            :dark="dark"
            class="text-decoration-underline"
            @click="subjectShow(item)"
            >{{ item.subject }}</a>             
        </template>  
        <!-- For Show Dialog             -->
        <template v-slot:top>
          <v-row align="center" dense>
            <!-- Show Dialog for each Action-->
            <v-dialog
              v-model="dialogAction" 
              scrollable
              persistent
              transition="dialog-bottom-transition"
            >              
              <v-card>
                <v-card-title class="cyan darken-1">
                  <span class="text-subtitle-2 white--text">{{ formTitle }}</span>

                  <v-spacer></v-spacer>

                  <v-btn
                    :dark="dark"
                    icon
                    @click="dialogAction = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                  <v-card >
                    <DxScrollView
                      height="100%"
                      width="100%">
                      <v-data-table
                        :mobile-breakpoint="800"
                        :mobile="mobile"
                        :headers="dialogActionHeaders"
                        :items="dialogActionList"
                        :dense="true"
                        :dark="dark"
                        hide-default-footer
                        :sort-by="[]"
                        :sort-desc="[false]"
                      ></v-data-table>
                    </DxScrollView>  
                  </v-card>
              </v-card>
            </v-dialog>
            <!-- Show subject detail -->
            <v-dialog
              v-model="dialogSubject" 
              scrollable
              persistent
              transition="dialog-bottom-transition"
            >
              
              <v-card>
                <v-card-title class="cyan darken-1">
                  <span class="text-subtitle-2 white--text">Description</span>

                  <v-spacer></v-spacer>

                  <v-btn
                    :dark="dark"
                    icon
                    @click="dialogSubject = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                  <v-card >
                    
                    <v-card-text class="text-subtitle-2 black--text font-weight-bold">
                      {{ formSubjectTitle }}
                    </v-card-text>
                      
                  </v-card>
              </v-card>
            </v-dialog>
            <!-- Show Comment detail -->
            <v-dialog
              v-model="dialogDetail" 
              fullscreen
              scrollable
              persistent
              :dark="dark"
            >            
              <v-card dense v-for=" item in gridDetailList" :key="item.rno">
                <v-card-title class="d-flex align-center cyan darken-1" >
                  <v-chip
                  class="mr-2"
                    color="white"
                    :dark="dark"
                    outlined
                  >
                    {{ item.rno }}
                  </v-chip>
                  <span class="text-subtitle-2 white--text">Detail Comment</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    :dark="dark"
                    icon
                    @click="dialogDetail = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <DxScrollView
                    height="100%"
                    width="100%">

                    <div>
                      
                      <v-card
                        class="mx-auto"
                      >
                        <div :dark="dark" 
                              class="d-flex flex-no-wrap justify-space-between grey darken-2" >
                          <div >
                            <v-card-title>Ship No</v-card-title>

                            <v-card-subtitle>{{ item.shipNo }}</v-card-subtitle>
                           
                          </div>
                          <div >
                            <v-card-title>Comment No</v-card-title>

                            <v-card-subtitle >{{ item.issueRefdoc }}</v-card-subtitle>
                           
                          </div>
                        </div>
                        <!-- Show Image Comment -->
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            ml="2"
                          >
                          <!-- :src="item.showImg" -->
                            <v-img
                              v-if="item.imgNo != null"
                              :src="content"
                              height="300px"
                              width="600px"
                              class="white--text align-end"
                            >                           
                              <div
                                class="d-flex flex-row mb-3"
                              >
                                <!-- Attach file Design -->
                                <v-btn 
                                  v-if="item.cntImgDsn != null"
                                  x-small
                                  color="primary"
                                  :dark="dark"
                                  @click="openFileDialog(item, 'R')"
                                >
                                  Design file: {{ item.cntImgDsn }}
                                </v-btn>
                                <!-- Attach file QM -->
                                <v-btn 
                                  v-if="item.cntImgQm != null"
                                  x-small
                                  color="primary"
                                  :dark="dark"
                                  @click="openFileDialog(item, 'C')"
                                  class="ml-2"
                                >
                                  QM file: {{ item.cntImgQm }}
                                </v-btn>
                                <!-- Attach file Production -->
                                <v-btn 
                                  v-if="item.cntImgPro != null"
                                  x-small
                                  color="primary"
                                  :dark="dark"
                                  @click="openFileDialog(item, 'A')"
                                  class="ml-2"
                                >
                                  Prod file: {{ item.cntImgPro }}
                                </v-btn>

                              </div>
                            
                            </v-img>                            
                          </v-col>
                        </v-row>
                        <!-- Show Expand Comment content -->
                        <div 
                          :dark="dark" 
                          class="grey darken-2 mt-n3" >
                          <v-card-actions 
                            dense 
                            @click="showContentComment = !showContentComment">
                            <v-card-title dense :style="{'font-size':'10pt'}">
                              Subject: {{ item.subject }}
                            </v-card-title>

                            <v-spacer></v-spacer>

                            <v-btn
                              dense
                              icon                            
                            >
                              <v-icon>{{ showContentComment ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </div>                       

                        <v-expand-transition >
                          <div v-show="showContentComment">
                            <v-divider></v-divider>

                            <v-card-subtitle class="mt-n1"
                              :style="{'font-size':'10pt'}"
                            >
                              Comment content:
                            </v-card-subtitle>
                            <v-card-title dense class="mt-n3"
                              :style="{'font-size':'10pt', 'font-weight': '300', 'line-height': '1.3rem', 'margin-inline': '5px'}"
                            >
                              {{ item.description }}
                            </v-card-title>
                          </div>
                        </v-expand-transition>
                        <v-divider></v-divider>
                        <!-- End show Image Comment -->  
                        <!-- QM Input Comment                      -->
                        <div dark class="grey darken-2">
                          <v-card-actions  @click="showQm = !showQm">
                            <v-btn
                              color="orange lighten-2"
                              text
                            >
                              QM Input Comment
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                              icon
                            >
                              <v-icon>{{ showQm ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </div>
                        <v-expand-transition>
                          <div v-show="showQm">
                            <v-divider></v-divider>

                            <template>
                              <v-form >
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.regDt"
                                        label="Input comment date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.clsNm"
                                        label="Publisher"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.owner"
                                        label="Ship Owner"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.qmPartNm"
                                        label="QM part"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.issueBy"
                                        label="Issue by"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.evtNm"
                                        label="Main event"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.rsnNm"
                                        label="Reason"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.regFull"
                                        label="QM Incharger"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </div>
                        </v-expand-transition>
                        <!-- 1st Action -->
                        <v-divider></v-divider>
                        <div dark class="grey darken-2">
                          <v-card-actions  @click="show1st = !show1st">
                            <v-btn
                              color="orange lighten-2"
                              text
                            >
                              1st Action
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                              icon
                            >
                              <v-icon>{{ show1st ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </div>
                        <v-expand-transition>
                          <div v-show="show1st">
                            <v-divider></v-divider>
                            <template>
                              <v-form >
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.codeNm"
                                        label="1st Group/section"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.deptNm1"
                                        label="1st Department"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.issueDt"
                                        label="Issue date by QM"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.statNm1"
                                        label="1st Status"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.cnfmDt"
                                        label="1st Confrim date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.replyDt"
                                        label="1st Reply date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.replyEmpnoNm1"
                                        label="1st Reply person"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-card-actions  @click="show1stContent = !show1stContent">
                                        <v-text-field
                                          v-model="item.rplyNm1"
                                          label="1st Reply content"
                                          dense
                                          disabled
                                        ></v-text-field>

                                        <v-spacer></v-spacer>

                                        <v-btn
                                          v-if="item.replyCtnt !=null"
                                          icon
                                        >
                                          <v-icon>{{ show1stContent ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                        </v-btn>
                                      </v-card-actions>

                                      <v-expand-transition v-if="item.replyCtnt !=null">
                                        <div v-show="show1stContent">
                                          <v-divider></v-divider>

                                          <v-card-text>
                                            Reply content: {{ item.replyCtnt }}
                                          </v-card-text>
                                        </div>
                                      </v-expand-transition>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.dlyNm1"
                                        label="1st Reply delay"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.trgtDt"
                                        label="1st target date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </div>
                        </v-expand-transition>

                        <v-divider></v-divider>
                        <div :dark="dark" 
                            class="grey darken-2" 
                          v-if="item.codeNm2 != null"
                        >
                          <v-card-actions  @click="show2nd = !show2nd">
                            <v-btn
                              color="orange lighten-2"
                              text
                            >
                              2nd Action
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                              icon
                            >
                              <v-icon>{{ show2nd ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </div>
                        
                        <v-expand-transition v-if="item.codeNm2 != null">
                          <div v-show="show2nd">
                            <v-divider></v-divider>
                            <template>
                              <v-form >
                                <v-container>
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.codeNm2"
                                        label="2nd Group/section"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.deptNm2"
                                        label="2nd Department"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.issueDt"
                                        label="Issue date by 2nd dept"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.statNm2"
                                        label="2nd Status"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.cnfmDt2"
                                        label="2nd Confrim date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.replyDt2"
                                        label="2nd Reply date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.replyEmpnoNm2"
                                        label="2nd Reply person"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                    <v-card-actions  @click="show2ndContent = !show2ndContent">
                                        <v-text-field
                                          v-model="item.rplyNm2"
                                          label="2nd Reply content"
                                          dense
                                          disabled
                                        ></v-text-field>                                      
                                        <v-spacer></v-spacer>

                                        <v-btn
                                          icon
                                          v-if="item.replyCtnt2 !=null"
                                        >
                                          <v-icon>{{ show2ndContent ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                        </v-btn>
                                      </v-card-actions>

                                      <v-expand-transition v-if="item.replyCtnt2 !=null">
                                        <div v-show="show2ndContent">
                                          <v-divider></v-divider>

                                          <v-card-text>
                                            Reply content: {{ item.replyCtnt2 }}
                                          </v-card-text>
                                        </div>
                                      </v-expand-transition>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.dlyNm2"
                                        label="2nd Reply delay"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>

                                    <v-col
                                      cols="12"
                                      sm="12"
                                      md="4"
                                      lg="2"
                                    >
                                      <v-text-field
                                        v-model="item.trgtDt2"
                                        label="2nd target date"
                                        dense
                                        disabled
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </template>
                          </div>
                        </v-expand-transition>                      
                      
                      </v-card>
                    </div>
                    
                </DxScrollView>
                
              </v-card>
              
            </v-dialog> 

          </v-row>
          
        </template>             

      </v-data-table>  
      <!-- Open Attach Files -->
      <div class="text-center">
        <v-dialog 
          v-model="dialogFile"                
          scrollable
          persistent
          transition="dialog-bottom-transition"
          top
        >
          <v-card>
            <v-card-title class="cyan darken-1">
              <span class="text-h8 white--text">{{ fileTitle }}</span>

              <v-spacer></v-spacer>

              <v-btn
                :dark="dark"
                icon
                @click="dialogFile = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card >
              <DxScrollView
                  height="100%"
                  width="100%">

                <v-data-table
                  :mobile-breakpoint="800"
                  :mobile="mobile" 
                  :headers="dialogFileHeaders"
                  :items="dialogFileList"
                  hide-default-footer
                  :sort-by="[]"
                  :sort-desc="[false]"
                  dense
                  :dark="dark"
                >
                  <template #[`item.rno`]="{ item }">
                    <v-chip
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                    >
                      {{ item.rno }}
                    </v-chip>
                  </template>

                  <!-- Open file -->
                  <template v-slot:[`item.openFile`]="{ item }">             
                    <v-chip
                      small
                      :color="getColor(item.rno)"
                      :dark="dark"
                      @click="fileOpen(item)"
                    >
                    Open file
                    </v-chip>
                  </template>
                </v-data-table> 
              </DxScrollView>   
              </v-card>              
          </v-card>              
        </v-dialog> 
        <!-- Show images here -->
        <v-dialog 
          v-if="!showpdf1"
          v-model="dialogShowFile"                
          scrollable
          persistent
          transition="dialog-bottom-transition"
          fullscreen
        >
          <v-card>
              <v-card-title class="cyan darken-1">
                <span class="text-subtitle-2 white--text">{{ titleFileName }}</span>

                <v-spacer></v-spacer>

                <v-btn
                  :dark="dark"
                  icon
                  @click="dialogShowFile = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card >
                <DxScrollView
                    height="100%"
                    width="100%">
                    <div style="height : 100%">
                      <v-img 
                        :src = "content1"
                        height="100%"
                        width="100%"
                        class="white--text align-end"
                      ></v-img>
                    </div>
                  
                </DxScrollView>   
                </v-card>              
            </v-card> 
        </v-dialog> 
      </div>
                          
    </v-card>

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark="dark"
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>  
</template>

<script>
  import  {
          mdiAccount,
          mdiPencil,
          mdiShareVariant,
          mdiDelete,
          mdiSelectSearch,
          mdiMapSearch 

        } from '@mdi/js'

  import  { getShipList, 
            getQMPartList,
            getSecCommentList,
            getQmEmployeeList,
            getTelephoneList,
            getEventList,
            getDivList,
            getPublisherList,
        } from '@/api/view/tqm/80/v80comm.js'

  import  {
          v80d1010List,
          v80d1010DetailList,
          v80d1010DetailFileList
        } from '@/api/view/tqm/80/v80d1010.js'

  import DxDateBox from 'devextreme-vue/date-box'
  import baseview from '@/components/base/baseview.vue' // base page addition
  import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
  import { DxScrollView } from "devextreme-vue/scroll-view";
  import { ftpDownload} from '@/api/view/tqm/common/common.js'
  import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

  import {
  getDateFormat,
  } from '@/utils/common.js'

  import dayjs from 'dayjs';

export default {
  name: "v80d1010",
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    DxScrollView,
    // AppButton,
  },
  data: () => ({
    Path : '',
    content:'',
    content1:'',
    showpdf: false,
    showpdf1: false,
    dark: false,
    fab: false,
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
      mdiSelectSearch,
      mdiMapSearch

    },
    // Popup
    makePop: false,
    // tooltip 
    subjectTitle:'',
    // Dialog
    dialogAction: false,
    dialogSubject: false,
    dialogDetail: false,
    dialogShowFile: false,
    titleFileName:'',
    editedIndex: -1,
    dialogActionList: [],
    titleActionDeptName:'',
    dialogDetailInputList:[],
    // Test Expansion panels
    panel: [0, 1, 2],
    readonly: false,
    showContentComment: true,
    showQm: true,
    show1st: true,
    show2nd: true,
    show1stContent: false,
    show2ndContent:false,
  /*  showItems:{
      dlNm: '',
      issueDt:'',
      cnfmDt:'',
      trgtDt:'',
      prodStopDt:'',
      stopDt:'',
      cntDays:'',
    }, */
    //File detail
    dialogFile: false,
    fileTitle:'',
    dialogFileHeaders: [
                      {
                        text: 'No',
                        align: 'center',
                        value: 'rno',
                        class:'light-green darken-3 white--text text-h8',
                        sortable: false, 
                      },
                      // { text: 'File No', divider: true, align: 'center', value: 'imgNo', class:'light-green darken-3 white--text text-h8' },
                      { text: 'File No', sortable: false, divider: true, align: 'center', value: 'imgNo', class:'light-green darken-3 white--text text-h8' },
                      { text: 'File type', sortable: false, divider: true, align: 'center', value: 'imgExt', class:'light-green darken-3 white--text text-h8' },
                      { text: 'Control file', sortable: false, divider: true, align: 'center', value: 'openFile', class:'light-green darken-3 white--text text-h8' },

    ],
    dialogFileList: [],
    //Detail
    dialogDetailInputHeaders:[],
    dialogActionHeaders: [
                {
                  text: 'Delay name',
                  align: 'start',
                  sortable: false,
                  value: 'dlNm',
                  divider: true,
                  class:'light-green darken-3 white--text',
                },
                { text: 'Issue date', sortable: false, divider: true, align: 'start',value: 'issueDt',class:'light-green darken-3 white--text' },
                { text: 'Close date', sortable: false, divider: true, align: 'start',value: 'cnfmDt',class:'light-green darken-3 white--text' },
                { text: 'Target date', sortable: false, divider: true, align: 'start',value: 'trgtDt',class:'light-green darken-3 white--text' },
                { text: 'Pro stop date', sortable: false, divider: true, align: 'start',value: 'prodStopDt',class:'light-green darken-3 white--text' },
                { text: 'QM stop date', sortable: false, divider: true, align: 'start',value: 'stopDt',class:'light-green darken-3 white--text' },
                { text: 'Count days', sortable: false, divider: true, align: 'start',value: 'cntDays',class:'light-green darken-3 white--text' },
              
              ],

    stDate: '',
    edDate: '',
    shipNoList: [],
    shipNo: '',

    deptName: '',
    deptNameList: [],
    deptCd: '',
    sectCd: '',

    respClsName: '',
    respClsNameList: [],
    respCls: '',

    clsCd: '',
    publisherName:'',
    publisherNameList: [],

    empNo: '',
    empName: '',
    empNameList: [],

  
    panel: [0],
    disabled: false,
    hover: true,

    // data
    gridMainList: [],
    listSize: 0,
    gridDetailList: [],
    gridDetailFileList: [],
    
    mobile: true,
    search: '', 
    hide2ndAction: false,
    headers: [
                { text: 'No', sortable: false, align: 'start', value: 'details', divider: true, class:'light-green darken-3 white--text', width:'250px' },
                { text: 'Ship No', sortable: false, divider: true, align: 'start',value: 'shipNo',class:'light-green darken-3 white--text' },
                { text: 'Status', sortable: false, divider: true, align: 'start',value: 'statNm',class:'light-green darken-3 white--text' },
                { text: 'Comment No', sortable: false, divider: true, align: 'start',value: 'issueRefDoc',class:'light-green darken-3 white--text' },
                { text: '1st Action', sortable: false, divider: true, align: 'start',value: 'action1',class:'light-green darken-3 white--text', visible: 'true'  },
                { text: '2nd Action', sortable: false, divider: true, align: 'start',value: 'action2',class:'light-green darken-3 white--text', visible: 'true' },
                { text: 'Subject', sortable: false, divider: true,align: 'start',value: 'subject', class:'light-green darken-3 white--text' },
                { text: 'Input Comment', sortable: false, divider: true,align: 'start',value: 'regDt', class:'light-green darken-3 white--text' },
                { text: 'Issue by', sortable: false, divider: true,align: 'start',value: 'issueOfcr', class:'light-green darken-3 white--text' },
                { text: 'QM PIC', sortable: false, divider: true,align: 'start',value: 'regEmpnoNm', class:'light-green darken-3 white--text' },
                { text: 'Main event', sortable: false, divider: true,align: 'start',value: 'evtNm', class:'light-green darken-3 white--text' },
                { text: 'Reason', sortable: false, divider: true,align: 'start',value: 'rsnNm', class:'light-green darken-3 white--text' },
              ],
      
        statCd1:true,
        statCd3:true,
        statCd5:true,
        statCd6:true,
        statCd7:true,
        statCd8:true,
        statCd9:false,
        statCdCan:false,
        // previousSelectedStructures: [],
        // status: ['Not Yet', 'Receipt', 'Reply final', 'QM return', 'FIN', 'Withdraw'],
        // chkStatus: ['Not Yet', 'Receipt', 'Reply final', 'QM return', 'FIN',],
  }),
  computed: {
    formTitle () {
          return this.editedIndex === -1 ? '1st Action: '  + this.titleActionDeptName : '2nd Action: ' + this.titleActionDeptName
        },

    formSubjectTitle (){
      return this.subjectTitle
        } ,  
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },

  mounted() {
    this.init()
  
  },

  methods: {
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset ||   e.target.scrollTop || 0
        this.fab = top > 20
      },
      toTop () {
        this.$vuetify.goTo(0)
      },
      
      btnRetrieve() {
          this.gridMainList = []        
          this.getMainList()
          
      },
      getStrFormat(date) {
        // this.stDate = getDateFormat(date)
        // this.fiDate = getDateFormat(date)
        return getDateFormat(date)
      },
      init() {
        let toDay = new Date      
        this.stDate = toDay.setDate(toDay.getDate() - 1);
        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate() + 1);

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

        this.getList()

      },    
      //getList
      async getList() {
        try {
            this.openLoading('searching')
            let params = {
              cdDiv: '',
              respCd: '21%'
            }

            // Department Division
            await getDivList(params).then(res => {
              // console.log('####getDivList===>', res)
              this.respClsNameList.push('All')
              res.list.forEach(e => {
                this.respClsNameList.push(e.respCls + ' : ' + e.respClsNm)
              });
              this.respClsName = this.respClsNameList[0]
            })

            // getShipList
            await getShipList(params).then(res => {
                    this.shipNoList.push('All')
                    res.list.forEach(e => {
                      this.shipNoList.push(e.shipNo)
                    });
                    this.shipNo = this.shipNoList[0]
                  })
            // Section Department
            await getSecCommentList(params).then(res => {
                    this.deptNameList.push('All')
                    res.list.forEach(e => {
                      this.deptNameList.push(e.sectCd + ' : ' + e.sectNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })          

            // Publisher
            await getPublisherList(params).then(res => {
              this.publisherNameList.push('All')
              res.list.forEach(e => {
                this.publisherNameList.push(e.clsCd + ' : ' + e.clsNm)
              });
              this.publisherName = this.publisherNameList[0]
            })

            // QM PIC List
            await getQmEmployeeList(params).then(res => {
              this.empNameList.push('All')
              res.list.forEach(e => {
                this.empNameList.push(e.empNo + ' : ' + e.empNm)
              });
              this.empName = this.empNameList[0]
            })
            


            } finally {

                this.endLoading()
            }

      },
          
      // changed(value) {
      //     let added = value.filter(
      //       (val) => !this.previousSelectedStructures.includes(val)
      //     );
      //     let removed = this.previousSelectedStructures.filter(
      //       (val) => !value.includes(val)
      //     );

      //     // Do some stuff
      //     console.log(value);
      //     this.previousSelectedStructures = value;
      // },
      async getMainList() {
          try {
              this.openLoading('searching')              
              // console.log("#####Result====>", this.resultInsp.resPnt)
              
              this.respCls = this.respClsName.split(' : ')[0]
              this.clsCd = this.publisherName.split(' : ')[0]  
              this.sectCd = this.deptName.split(' : ')[0]
              this.empNo  = this.empName.split(' : ')[0]
              // this.chkStatus 
              
              let params = {
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                clsCd: this.clsCd ==='All' ? '' : this.clsCd,
                respCls: this.respCls === 'All' ? '' : this.respCls,
                sectCd: this.sectCd === 'All' ? '%' : this.sectCd,
                deptCd:  this.sectCd === 'All' ? '' : this.sectCd.substring(0,2),
                statCd1: this.statCd1 === true ? '1' : '',
                statCd3: this.statCd3 === true ? '3' : '',
                statCd5: this.statCd5 === true ? '5' : '',
                statCd6: this.statCd7 == true ? '6' : '',
                statCd7: this.statCd7 == true ? '7' : '',
                statCd8: this.statCd5 === true ? '8' : '',
                statCd9: this.statCd9 == true ? '9' : '',
                statCdCan: this.statCdCan === true ? 'C' : '',
                stDate: this.stDate,
                edDate: this.edDate,
                empNo: this.empNo === 'All' ? '' : this.empNo

              }
              
              // console.log('######getMainList===>', params)

              await v80d1010List(params).then(res => {
                let list = []
                let cnt = 1;
                // console.log('######v80d1010List===>', res)
                  res.list.forEach(e => {
                    // this.hide2ndAction = (e.nm2nd=== null? true :false)

                    list.push({
                      rno: cnt++,
                      shipNo: e.shipNo,
                      clsCd: e.clsCd,
                      cmtSeq: e.cmtSeq,
                      statCd: e.statCd,
                      subject: e.subject ,
                      issueOfcr: e.issueOfcr,
                      issueDt: e.issueDt,
                      issueDt1: e.issueDt1,
                      passday: e.passday,
                      regEmpno: e.regEmpno,
                      regDt: e.regDt,
                      deptCd: e.deptCd,
                      rsnCd: e.rsnCd,
                      description: e.description,
                      codeNm: e.codeNm,
                      nm1st: e.nm1st,
                      nm2nd: e.nm2nd === null ? '' : e.nm2nd,
                      replyCtnt1: e.replyCtnt1,
                      replyCtnt2: e.replyCtnt2,
                      rrespCd: e.rrespCd,
                      rstatCd: e.rstatCd,
                      rchkDt: e.rchkDt,
                      crespCd: e.crespCd,
                      cstatCd: e.cstatCd,
                      cchkDt: e.cchkDt,
                      respChgReq: e.respChgReq,
                      rcnfmDt: e.rcnfmDt,
                      ccnfmDt: e.ccnfmDt,
                      rregDt: e.rregDt,
                      cregDt: e.cregDt,
                      dlCd: e.dlCd,
                      dlCd1: e.dlCd1,
                      prodStopdt: e.prodStopdt,
                      prodStopdt1: e.prodStopdt1,
                      stopDt: e.stopDt,
                      stopDt1: e.stopDt1,
                      matDt: e.matDt,
                      matDt1: e.matDt1,
                      cntDays: e.cntDays,
                      cntDays1: e.cntDays1,
                      cnfmDt: e.cnfmDt,
                      cnfmOfcr: e.cnfmOfcr,
                      issueRefDoc: e.issueRefDoc,
                      rremark: e.rremark,
                      cremark: e.cremark,
                      ord: e.ord,
                      importantYn: e.importantYn,
                      qmPart: e.qmPart,
                      hvsYn: e.hvsYn,
                      block: e.block,
                      matlDly: e.matlDly,
                      trgtDt: e.trgtDt,
                      trgtDt2: e.trgtDt2,
                      cprodYn: e.cprodYn,
                      rprodYn: e.rprodYn,
                      cmatYn: e.cmatYn,
                      rmatYn: e.rmatYn,
                      cnf2Yn: e.cnf2Yn,
                      qmGrp: e.qmGrp,
                      dlyDay: e.dlyDay,
                      mevt: e.mevt,
                      evtNm: e.evtNm,
                      statNm: e.statNm,
                      statNm1: e.statNm1,
                      statNm2: e.statNm2===null ?'': e.statNm2,
                      rsnNm: e.rsnNm,
                      regEmpnoNm: e.regEmpnoNm,
                      dlNm: e.dlNm,
                      dlNm1: e.dlNm1,
                    })
                    
                  });

                  this.gridMainList = list
                  this.listSize = list.length

                  if (this.listSize > 0){
                    this.panel = []
                  }
                  // console.log('######listSize===>', this.listSize)
              })

          } finally {
              this.endLoading()
          }
      },

      async getDetailList(obj) {
            
        // console.log('######getDetailList===>', obj)
          try {
              this.openLoading('searching')            
              // console.log('######getDetailList===>', obj)

              let params = {
                // shipNo:"S50806",
                //  clsCd:"O",
                // cmtSeq:"00048"
                shipNo: obj.shipNo,
                clsCd: obj.clsCd,
                cmtSeq: obj.cmtSeq,

              }
              
              // console.log('######getMainList===>', params)

              await v80d1010DetailList(params).then(res => {
                let list = []
                // console.log('######v80d1010DetailList===>', res)
                  res.list.forEach(e => {
                    // Show file JPG
                    if(e.imgNo != null){

                      this.Path = 'attachfile/QC/COMMENT/'+ e.imgNo + '.' + e.imgExt;
                      var dirs = this.Path.split('/');    
                      var t1 =  dirs[dirs.length - 1];
                      var fname = t1.split('.');
                      var extend = fname[1];
                      var datatype = "";
                      fname = fname[0].replace(/ /g, "")

                      // console.log("#####Path===>", this.Path )
                      // console.log("#####imgExt===>", e.imgExt )

                      if(extend.toUpperCase() === 'PDF'){
                        datatype = "data:application/pdf;base64,";
                        this.showpdf = true;
                      }
                      else{
                        datatype = "data:image/" + extend + ";base64,";
                        this.showpdf = false;
                      }
                      // console.log("#####showpdf===>", this.showpdf )
                      ftpDownloadViewer(this.Path, fname).then((res) =>{        
                        this.content = datatype + res.body;
                        // console.log("#####ftpDownloadViewer===>", this.content )

                      }).catch(error => {
                        alert('This file is not existed. Please contact HVS PIC!');
                      })
                      .finally(() => {
                      })
                    }
                    

                    list.push({
                      rno: obj.rno,
                      shipNo: e.shipNo,
                      clsCd: e.clsCd,
                      clsNm: e.clsNm,
                      cmtSeq: e.cmtSeq,
                      rsnCd: e.rsnCd,
                      rsnNm: e.rsnNm,
                      issueCls: e.issueCls,
                      complyCd: e.complyCd,
                      wkKind: e.wkKind,
                      stgCd: e.stgCd,
                      block: e.block,
                      issueDt: e.issueDt,
                      cmtYn: e.cmtYn,
                      issueDt2: e.issueDt2,
                      regDt: e.regDt,
                      cnfmDt: e.cnfmDt,
                      cnfmDt2: e.cnfmDt2,
                      qmCnfmDt: e.qmCnfmDt,
                      qmCnfmDt2: e.qmCnfmDt2,
                      prodStopDt1: e.prodStopDt1,
                      prodStopDt2: e.prodStopDt2,
                      prodStopEmp1: e.prodStopEmp1,
                      prodStopEmp2: e.prodStopEmp2,
                      matArrDt1: e.matArrDt1,
                      matArrDt2: e.matArrDt2,
                      matArrEmp1: e.matArrEmp1,
                      matArrEmp2: e.matArrEmp2,
                      delayStopDte1: e.delayStopDte1,
                      delayStopDte2: e.delayStopDte2,
                      delayArriDte1: e.delayArriDte1,
                      delayArriDte2: e.delayArriDte2,
                      regEmpno: e.regEmpno,
                      regEmpnoNm: e.regEmpnoNm,
                      regFull: e.regEmpno + ': ' + e.regEmpnoNm,
                      tel: e.tel,
                      issueOfcr: e.issueOfcr,
                      cnfmOfcr: e.cnfmOfcr,
                      cnfmOfcr2: e.cnfmOfcr2,
                      ncrCode: e.ncrCode,
                      issueRefdoc: e.issueRefdoc,
                      issueRefinfo: e.issueRefinfo,
                      location: e.location,
                      subject: e.subject,
                      description: e.description,
                      suggestion: e.suggestion,
                      seriesYn: e.seriesYn,
                      cmtnoCd: e.cmtnoCd,
                      issueDoc3: e.issueDoc3,
                      drawNo: e.drawNo,
                      ownsDocno: e.ownsDocno,
                      issueBy: e.issueBy,
                      importantYn: e.importantYn,
                      imgNo: e.imgNo,
                      fileName: e.fileName,
                      imgExt: e.imgExt,
                      showImg: e.showImg,
                      dwgFile: e.dwgFile,
                      replyEmpno: e.replyEmpno,
                      replyEmpnoNm1: e.replyEmpnoNm1,
                      replyEmpno2: e.replyEmpno2,
                      replyEmpnoNm2: e.replyEmpnoNm2,
                      respCls: e.respCls,
                      gbanCd: e.gbanCd,
                      gbanCd2: e.gbanCd2,
                      respCd: e.respCd,
                      deptNm1: e.deptNm1,
                      respCd2: e.respCd2,
                      deptNm2: e.deptNm2,
                      jumuYn: e.jumuYn,
                      jumuYn2: e.jumuYn2,
                      statCd: e.statCd,
                      statNm1: e.statNm1,
                      statCd2: e.statCd2,
                      statNm2: e.statNm2,
                      respchgReq: e.respchgReq,
                      replyDt: e.replyDt,
                      replyDt2: e.replyDt2,
                      replyCtnt: e.replyCtnt,
                      replyCtnt2: e.replyCtnt2,
                      remark: e.remark,
                      remark2: e.remark2,
                      codeNm: e.codeNm,
                      codeNm2: e.codeNm2,
                      deptSect1: e.deptSect1,
                      deptSect2: e.deptSect2,
                      recvDt: e.recvDt,
                      acptYn: e.acptYn,
                      replyTel: e.replyTel,
                      chkEmpno: e.chkEmpno,
                      chkDt: e.chkDt,
                      matlDly: e.matlDly,
                      matrDate: e.matrDate,
                      qmPart: e.qmPart,
                      qmPartNm: e.qmPartNm,
                      hvsYn: e.hvsYn,
                      qmYn: e.qmYn,
                      haveYn: e.haveYn,
                      chkYn: e.chkYn,
                      dsnYn: e.dsnYn,
                      cmtnoDoc1: e.cmtnoDoc1,
                      cmtnoDoc2: e.cmtnoDoc2,
                      trgtDt: e.trgtDt,
                      trgtDt2: e.trgtDt2,
                      mainSta: e.mainSta,
                      dlyCd1: e.dlyCd1,
                      dlyNm1: e.dlyNm1,
                      dlyCd2: e.dlyCd2,
                      dlyNm2: e.dlyNm2,
                      rplyCd1: e.rplyCd1,
                      rplyNm1: e.rplyNm1,
                      rplyCd2: e.rplyCd2,
                      rplyNm2: e.rplyNm2,
                      owner: e.owner,
                      prodDiv1st: e.prodDiv1st,
                      hotWk: e.hotWk,
                      majYn: e.majYn,
                      weekYn: e.weekYn,
                      prodYn1: e.prodYn1,
                      prodYn2: e.prodYn2,
                      matArrYn1: e.matArrYn1,
                      matArrYn2: e.matArrYn2,
                      qmApprStopStat1: e.qmApprStopStat1,
                      qmApprStopStat2: e.qmApprStopStat2,
                      evtNm: e.evtNm,
                      stopRsnCd: e.stopRsnCd,
                      stopRsnNm: e.stopRsnNm,
                      stopRsnCd2: e.stopRsnCd2,
                      stopRsnNm2: e.stopRsnNm2,
                      qmApprStopDte1: e.qmApprStopDte1,
                      qmApprStopDte2: e.qmApprStopDte2,
                      porNo: e.porNo,
                      msys: e.msys,
                      lsys: e.lsys,
                      ssys: e.ssys,
                      mevt: e.mevt,
                      cntImgDsn: e.cntImgDsn,
                      cntImgQm: e.cntImgQm,
                      cntImgPro: e.cntImgPro,
                    })
                    
                  });

                  this.gridDetailList = list
                  // console.log('######gridDetailList===>', this.gridDetailList)
              })

          } finally {
              this.endLoading()
          }
      },
    
    //File list
    async initialize (obj, div) {
        try {
              this.openLoading('searching') 

              let params = {                
                  shipNo: obj.shipNo,
                  clsCd: obj.clsCd,
                  cmtSeq: obj.cmtSeq,
                  div: div

              }
              
              // console.log('######paramsFileDialog===>', params)

              await v80d1010DetailFileList(params).then(res => {
                let list = []
                let cnt = 1
                // console.log('######v80d1010DetailFileList===>', res)
                  res.list.forEach(e => {
                    list.push({
                      rno: cnt++,
                      imgNo: e.imgNo,
                      fileName: e.fileName,
                      imgExt: e.imgExt,
                      div: e.div
                    })
                    
                  });

                  this.dialogFileList = list
                  // this.listSize = list.length

                  // console.log('######listSize===>', this.dialogFileList)
              })

          } finally {
              this.endLoading()
          }
      
    },

    getColor (value) {
        if (value > 40) return 'red'
        else if (value > 20) return 'orange'
        else return 'green'
    },  

    setColorStatus (str) {
        if (str === '1') return 'red'
        else if (str === '3') return 'indigo'
        else if (str === '5'||str === '8') return 'green darken-1'
        else if (str === '6'||str === '7') return 'blue'
        else if (str === '9') return 'amber'
        else return 'orange'
    },  

    showItemAction(e, index){
      this.editedIndex = index
      if(index === -1){
        this.titleActionDeptName = e.nm1st
        this.dialogActionList = [{dlNm: e.dlNm, 
                        issueDt: e.issueDt, 
                        cnfmDt: e.rcnfmDt, 
                        trgtDt: e.trgtDt, 
                        prodStopDt: e.prodStopdt, 
                        stopDt:e.stopDt, 
                        cntDays:e.cntDays},]
      }else{
        this.titleActionDeptName = (e.nm2nd === null ? '' : e.nm2nd)
        this.dialogActionList = [{dlNm: e.dlNm1,
                          issueDt: e.issueDt1,
                          cnfmDt: e.ccnfmDt,
                          trgtDt: e.trgtDt2,
                          prodStopDt: e.prodStopdt1,
                          stopDt: e.stopDt1,
                          cntDays: e.cntDays1},]
      }

      this.dialogAction = true
      
      // console.log("#####showItemAction===>", this.showItemAction )

    },

    subjectShow(e){
      // console.log("#####subjectShow===>", e.description)
      this.subjectTitle = (e.description === null ? '' : e.description)   
      this.dialogSubject = true

      // console.log("#####subjectShow===>", this.dialogSubject)

    },

    showDetailComment(e){
      // console.log("#####showDetailComment===>", e)
      this.getDetailList(e)

      this.showQm = true
      this.show1st = true
      this.show2nd = true
      this.dialogDetail = true 
      this.showContentComment = true   

    },

    //openFileDialog
    openFileDialog (item, div) {
      // console.log('#####openFileDialog====>', item)

      // this.dialogFile = true

      if(div==='R'){
        this.fileTitle = 'Design attach file'
      }else if(div==='A'){
        this.fileTitle = 'Production attach file'
      }      
      else{
        this.fileTitle = 'QM attach file'
      }

      // console.log('#####dialogFile====>', this.fileTitle)
      if(item.cntImgDsn > 0 || item.cntImgQm > 0 || item.cntImgPro > 0){
        this.initialize(item, div)
        this.dialogFile = true
      }else{
        this.vToastify(this.$t('Sorry!, No attach file!'), 'warn')
        this.dialogFile = false
      }


    },

    fileOpen(e){
        this.dialogShowFile = true
        this.titleFileName = e.imgNo + '.' + e.imgExt;
      // console.log('######fileOpen===>', e)
        let dirPath = 'attachfile/QC/COMMENT/';

        let fileType = e.imgExt;
        let filePath = dirPath + e.imgNo + '.' + fileType;

        var dirs = fileType.split('/');    
        var t1 =  dirs[dirs.length - 1];
        var fname = t1.split('.');
        // var extend = fname[1];
        var datatype = "";
        fname = fname[0].replace(/ /g, "")
        
        // console.log('######fileType===>', fileType)
        // console.log('######fileNo===>', e.imgNo)
        if(fileType.toUpperCase() ==='PDF'){
          datatype = "data:application/pdf;base64,";
          this.showpdf1 = true;
          this.openLoading('searching')
          ftpDownload(filePath, e.imgNo)
          .finally(() => {
            this.endLoading()
          })
          
        }else{
          datatype = "data:image/" + fileType + ";base64,";
          this.showpdf1 = false;

          this.openLoading('searching')
          ftpDownloadViewer(filePath, fname).then((res) =>{
            this.content1 = datatype + res.body;
          }).catch(error => {
            alert('This file is not existed. Please contact HVS PIC!');
          })
          .finally(() => {
            this.endLoading()
          })
        }
       
        
    },

  },

};
</script>
<style >

/* Start button invert-colors */
.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
    top: 10px;
}

.v-btn--fab.v-size--default {
    height: 45px;
    width: 45px;
}

.v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right {
    right: 40px;
}

/* End button invert-colors */

/* Setting for Contion search */
.v-expansion-panel-header {
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: 0.9375rem;
    line-height: 0.5;
    min-height: 40px;
    outline: none;
    padding: 10px 10px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    background: silver;
}

.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 50px;
}

.v-expansion-panel-content__wrap {
    padding: 0 4px 4px;
    flex: 1 1 auto;
    max-width: 100%;
}
.v-data-table-header th {
white-space: nowrap;
}

.font-class-name * {
   font-size: 12px;
}

/* height for each row */
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 30px;
}

/* Size font */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 10pt;
    height: 30px;
}

.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 95%;
}
.v-dialog {
    border-radius: 4px;
    margin: 0px;
    overflow-y: auto;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    outline: none;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.v-card__subtitle, .v-card__text, .v-card__title {
    padding: 5px;
}

.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 11pt;
    font-weight: 500;
    letter-spacing: 0.0125rem;
    line-height: 2rem;
    word-break: break-all;
}

.container {
    width: 100%;
    padding: 2px;
    margin-right: auto;
    margin-left: auto;
}

</style>
